import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'icon']);

const ITEMS_PER_ROW = {
  base: 3,
  md: 4,
  lg: 6,
  xl: 8,
};

const GAP_SIZE = 4;
const GAP_PX = 16;

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "icon")[]
 * }>} IconSetStyles
 */
export const iconSetStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args - Component arguments
   * @param {Contentful.IconSet} args.component - IconSet component data
   * @param {boolean} [args.isComplete] - Whether component has all fields
   * @param {boolean} [args.isFetching] - Whether additional data is being fetched
   *
   * @returns {IconSetStyles} - Component styles
   */
  baseStyle({component}) {
    return {
      root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        gap: GAP_SIZE,
      },
      icon: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
    };
  },
  variants: {
    horizontal: ({component}) => {
      const calculateWidth = (itemsPerRow) => {
        const gaps = (itemsPerRow - 1) * GAP_PX;

        return `calc((100% - ${gaps}px) / ${itemsPerRow})`;
      };

      return {
        icon: {
          flex: {
            base: `0 0 ${calculateWidth(ITEMS_PER_ROW.base)}`,
            md: `0 0 ${calculateWidth(ITEMS_PER_ROW.md)}`,
            lg: `0 0 ${calculateWidth(ITEMS_PER_ROW.lg)}`,
            xl: `0 0 ${calculateWidth(ITEMS_PER_ROW.xl)}`,
          },
          maxWidth: {
            base: calculateWidth(ITEMS_PER_ROW.base),
            md: calculateWidth(ITEMS_PER_ROW.md),
            lg: calculateWidth(ITEMS_PER_ROW.lg),
            xl: calculateWidth(ITEMS_PER_ROW.xl),
          },
        },
      };
    },
  },
  defaultProps: {
    variant: 'horizontal',
  },
});
